module.exports = __webpack_public_path__ + "media/3.c61b9666.mp3";